class DeploymentSwitchService {
    /**
     * Checks whether a deployment switch is enabled or not by looking for a  data attribute (data-switch-wos{number}="true") on the HTML tag
     */
    constructor() {
        const attributes = document.documentElement.attributes;

        for (const key in attributes) { // eslint-disable-line no-restricted-syntax
            if (attributes[key].name && (attributes[key].name).indexOf('data-switch-') === 0) {
                this[attributes[key].name.replace('data-switch-', '')] = attributes[key].value === 'true';
            }
        }
    }
}

module.exports = DeploymentSwitchService;

if (!('wowDeploymentSwitch' in window)) {
    window.wowDeploymentSwitch = new DeploymentSwitchService();
}



// WEBPACK FOOTER //
// ./src/common/deploymentswitch/deployment-switch.service.js